import { cn } from "@/lib/utils"
import { Check, LucideIcon } from "lucide-react"

interface AgentTypeCardProps {
  icon: LucideIcon
  label: string
  description: string
  selected: boolean
  disabled?: boolean
  disabledReason?: string
  onSelect: () => void
}

/**
 * The first decision on the page, so it gets real estate rather than a
 * dropdown: two cards, one glance, one click.
 */
export function AgentTypeCard({
  icon: Icon,
  label,
  description,
  selected,
  disabled,
  disabledReason,
  onSelect,
}: AgentTypeCardProps) {
  return (
    <button
      type="button"
      onClick={onSelect}
      disabled={disabled}
      aria-pressed={selected}
      title={disabled ? disabledReason : undefined}
      className={cn(
        "group relative flex w-full flex-col items-start gap-1 rounded-lg border p-4 text-left transition-all",
        "hover:border-pear-teal/60 hover:shadow-sm",
        selected
          ? "border-pear-teal bg-pear-teal/5 ring-1 ring-pear-teal"
          : "border-border bg-card",
        disabled && "cursor-not-allowed opacity-50 hover:border-border hover:shadow-none"
      )}
    >
      {selected && (
        <span className="absolute right-3 top-3 flex h-5 w-5 items-center justify-center rounded-full bg-pear-teal text-white">
          <Check className="h-3 w-3" strokeWidth={3} />
        </span>
      )}
      <span
        className={cn(
          "mb-1 flex h-9 w-9 items-center justify-center rounded-md transition-colors",
          selected
            ? "bg-pear-teal text-white"
            : "bg-muted text-muted-foreground group-hover:text-foreground"
        )}
      >
        <Icon className="h-5 w-5" />
      </span>
      <span className="font-medium">{label}</span>
      <span className="text-sm text-muted-foreground">
        {disabled && disabledReason ? disabledReason : description}
      </span>
    </button>
  )
}
